import InputAutosuggest from './InputAutosuggest';

export default InputAutosuggest;
